import React, { FC, PropsWithChildren } from 'react';

export const Asterix: FC<PropsWithChildren> = ({ children }) => (
  <span className="ml-1 text-destructive">{children}</span>
);
